import { Box, Button, CircularProgress, Container, Modal, Slider, Stack, Typography } from "@mui/material";
import moment, { Moment } from "moment";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { generatePayOrder, queryPayOrderStatus } from "../../lib/api";
import { calcTimeByMonthWithDate, str2Day } from "../../lib/util";
import { store } from "../../redux/store";
import * as requestAction from "../../redux/action/requestAction"

const marks = [
    {
      value: 1,
      label: '1个月',
    },
    {
      value: 3,
      label: '1个季度',
    },
    {
      value: 6,
      label: '半年',
    },
    {
      value: 12,
      label: '1年',
    },
    {
        value: 18,
        label: '1年半',
      },
    {
        value: 24,
        label: '2年',
      },
  ];
export function Renew(){

    const navigate = useNavigate();
    function valuetext(value: number) {
        return `${value}个月`;
    }
    const row = useLocation().state;
    const expireDate1:Moment = str2Day(row.expireDate);
    const expireDate = expireDate1.isAfter(moment())?expireDate1:moment();

    const [renewMonth,setRenewMonth] = useState(1);
    const [price,setPrice] = useState(row.price);
    const [open, setOpen] = useState(false);
    const [payStatus,setPayStatus] = useState("init");
    const [payMessage, setPayMessage] = useState("");
    const [newExpireDate, setNewExpireDate] = useState(calcTimeByMonthWithDate(expireDate,-1*renewMonth));
    

    const handleChange = (event: Event, newValue: number | number[]) => {
        const month = newValue as number;
        setRenewMonth(month);
        setPrice(month*row.price);
        setNewExpireDate(calcTimeByMonthWithDate(expireDate,-1*month));
    };
    /**
     * 请求支付
     * @param row 
     */
    async function requestPay(row:any){

      const productName = `${row.tag}续期${renewMonth}个月`;
      const orderType = "远程桌面通道续期服务";
      const {data,headers} = await generatePayOrder(row.id,productName,orderType,price,renewMonth);
      console.log("headers=",headers);
      const outTradeNo = headers["outtradeno"];
      if(!outTradeNo){
        store.dispatch(requestAction.warning("支付订单创建失败，请稍后再试"));
        return;
      }
      const newWindow = window.open("","_blank");
      newWindow?.document.write(data);
      newWindow?.focus();

      setPayMessage("等待支付结果中...");
      setOpen(true);
      // 10s之后，每隔2s查询一次交易状态
      setTimeout(()=>{
        const queryTask = setInterval(async ()=>{
          const kbResult = await queryPayOrderStatus(outTradeNo);
          if(!kbResult.success){
            setPayMessage("");
            setOpen(false);
            store.dispatch(requestAction.warning(kbResult.status.describe));
            clearInterval(queryTask);
            return;
          }
          const {payStatus} = kbResult.response;
          setPayStatus(payStatus as string);
          if(payStatus === "success"){ // 支付失败
            setPayMessage(`支付成功，感谢您的支持。桌面通道：${row.tag}已成功续期到:${newExpireDate.format("YYYY-MM-DD")}`);
            setOpen(true);
            clearInterval(queryTask);
            return;
          }
          if(payStatus === "fail"){ // 支付失败
            setPayMessage("支付失败");
            setOpen(true);
            clearInterval(queryTask);
            return;
          }
          if(payStatus === "init" || payStatus === "processing"){ // 继续轮询支付结果
            setPayMessage("等待支付结果中...");
            setOpen(true);
          }
          
        },2000);
      },10*1000);
    }

    return (
        <Container sx={{bgcolor: 'rgb(245, 245, 245)', height: window.innerHeight - 64 }}>
          <Box sx={{marginTop:10}}>
              <Typography variant="h5">{`桌面通道：${row.tag}`}</Typography>
              <Typography variant="h6">{`远程桌面续期服务`}</Typography>
              <Typography variant="body2">{`当前服务日期：${expireDate.format("YYYY-MM-DD")}`}</Typography>
              <Typography variant="body2">{`续期服务日期：${newExpireDate.format("YYYY-MM-DD")}`}</Typography>
              <Typography variant="body2">{`费用：${price}元`}</Typography>
          </Box>
          <Slider
              style={{marginTop:50}}
              aria-label="Temperature"
              defaultValue={renewMonth}
              getAriaValueText={valuetext}
              valueLabelDisplay="on"
              step={1}
              value={renewMonth}
              onChange={handleChange}
              min={1}
              max={24}
              marks={marks}
          />
          <Stack direction="row" spacing={2}>
              <Button variant="outlined" onClick={()=>{requestPay(row)}}>支付宝支付{price}元</Button>
              <Button variant="outlined" onClick={()=>{navigate("/console/desktop")}}>返回</Button>
          </Stack>
          <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
              <Container sx={style}>
                {
                (payStatus === "init" || payStatus === "processing") &&
                <CircularProgress/>
                }
                <Typography variant="body2" id="modal-modal-description" style={{marginBottom:20}} sx={{ mt: 2 }}>
                  {payMessage}
                </Typography>
                <Stack  direction="row" spacing={2}>
                  {
                  payStatus === "success" && 
                  <Button variant="outlined" color="success" onClick={()=>{navigate("/console/desktop")}}>返回列表页面</Button>
                  }
                  {
                  payStatus === "fail" && 
                  <>
                    <Button variant="outlined" color="error" onClick={()=>{setOpen(false);setPayStatus("init")}}>重新续期</Button>
                    <Button variant="outlined" color="success" onClick={()=>{navigate("/console/desktop")}}>返回列表页面</Button>
                  </>
                  }
                </Stack>
              </Container>
          </Modal>
        </Container>
    )
}

const style = {
  position: 'absolute' as 'absolute',
  top: '30%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  justifyContent:"center",
  alignItems:"center"
};